import {
  Component,
  OnInit,
  Compiler,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { first, retry } from 'rxjs/operators';
import { Router } from '@angular/router';
import { FormBuilder, Validators, FormControl } from '@angular/forms';
import { NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { AppConfig } from '../util';
import { CommonService } from '../service/commons-service';
import { Common } from '../util/common';
import { ExcelService } from '../service/excel.service';
import { HeaderCustomComponent } from '../header/headerCustom.component';

@Component({
  templateUrl: 'selfRatingSection.component.html',
  styleUrls: ['selfRatingSection.component.css'],
})
export class SelfRatingSectionComponent implements OnInit {
  @ViewChild('closeModel1', { read: ElementRef }) closeModel1: ElementRef;
  @ViewChild('closeModel2', { read: ElementRef }) closeModel2: ElementRef;
  notAbleToFillRating: boolean = false;
  showHideModel: boolean = false;
  loading: boolean = false;
  isAppr: number;
  isDisabled: boolean = true;
  isDisabledView: boolean = true;
  message = '';
  modelData: any[] = [];
  users: any = {};
  behavioralSkillRatingForm: any;
  functionalSkillRatingForm: any;
  config: any;
  fetchData: any[] = [];
  submitted = false;
  loginImageURL: any = '';
  baseURL: any = null;
  loginUserName: any = '';
  isShowModel: boolean = true;
  skillData: any[] = [];
  behSkillList: any[] = [];
  //Add users form fields
  userUpdatedId: Number = 0;
  skillRatingFromDate: any;
  towerId: number = 0;
  userRole: number = 0;
  skillRatingData: any[] = [];
  selectedPositionId: Number = 0;
  dateRanges: any[] = [1];
  fullFunRatingList: any;
  fullBehRatingList: any;
  convertedData: any[][] = [];
  allPositions: any = [];
  positionList: any;
  isNextTowerSame: boolean = true;
  ibuList: any = [];
  ibu: any = '';
  functionList: any = [];
  function: any = '';
  selectedIbuId: any = null;
  alltowerList: any = [];
  towerList: any = [];
  selectedTowerId: any;
  tower: any = '';
  nextPositionId: number = undefined;

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private excelService: ExcelService,
    private commonService: CommonService,
    private common: Common,
    private appConfig: AppConfig,
    config: NgbDatepickerConfig,
    private _compiler: Compiler
  ) {
    this._compiler.clearCache();
    this.users = JSON.parse(localStorage.getItem('user'));
    if (!this.users || !this.users.userData) {
      this.commonService.logout();
      return;
    }
    if (this.users && this.users.userData) {
      this.users = this.users.userData;
      if (this.users.userFullName) {
        this.loginUserName = this.users.userFullName;
        this.users.userFullName = this.users.userFullName.toLowerCase();
      } else {
        this.loginUserName = this.users.userName;
        this.users.userFullName = this.users.userName.toLowerCase();
      }
      if (
        !this.users.emailAddress ||
        this.users.emailAddress.trim().length == 0
      ) {
        this.users['emailAddress'] = this.users.email;
      }
      this.userRole = this.users.userRoll;
      this.towerId = this.users.towerId;
      this.nextPositionId = this.users.nextPosition;
      debugger;
    }
    let currentDate = new Date();
    this.config = config;
    this.config.minDate = {
      year: currentDate.getFullYear(),
      month: currentDate.getMonth() + 1,
      day: currentDate.getDate(),
    };
    this.config.markDisabled = false;
    this.loginImageURL = this.appConfig.getDefaultImgURL();
    this.fetchSkillsData();
    this.getAllBehSkills();
  }

  ngOnInit() {
    if (JSON.parse(localStorage.user).userData.userRoll == 3) {
      this.router.navigate(['/interested-users']);
    }
    this.fetchSkillRatingData();
    if (this.userRole == 1) {
      this.fetchUserData(null, null);
    } else if (this.userRole == 5 || !this.userRole) {
      this.fetchUserData(this.users.userId, this.towerId);
    } else {
      this.fetchUserData(null, this.towerId);
    }
    this.initalizeFunSkillForm();
    this.initalizeBehSkillForm();
    this.fetchPositions();
    this.getAllIBUInfo();
  }

  // initalize Functional Skill Form
  private initalizeFunSkillForm() {
    this.userUpdatedId = 0;
    this.selectedPositionId = 0;
    let groupForm = {
      skillRatingFromDate: [],
      skillRatingToDate: [],
    };
    if (this.skillData && this.skillData.length > 0) {
      for (let i = 0; i < this.skillData.length; i++) {
        groupForm[this.skillData[i].skillName] = new FormControl(
          '1',
          Validators.required
        );
      }
    }
    this.functionalSkillRatingForm = this.formBuilder.group(groupForm);
  }

  //Initalize Behavioral Skill Form
  private initalizeBehSkillForm() {
    this.userUpdatedId = 0;
    this.selectedPositionId = 0;
    let groupForm = {
      skillRatingFromDate: [],
      skillRatingToDate: [],
    };

    if (this.behSkillList && this.behSkillList.length > 0) {
      for (let i = 0; i < this.behSkillList.length; i++) {
        groupForm[this.behSkillList[i].skillName] = new FormControl(
          '1',
          Validators.required
        );
      }
    }
    this.behavioralSkillRatingForm = this.formBuilder.group(groupForm);
  }

  // /fetch user information data
  private fetchSkillRatingData() {
    this.skillRatingData = [];
    this.commonService
      .fetchSkillRatingData()
      .pipe(first())
      .subscribe(
        (data) => {
          if (data && data.length > 0) {
            this.skillRatingData = data;
          } else {
            localStorage.setItem('errorMsg', 'Data Not Found');
            this.commonService.showerror();
            localStorage.removeItem('errorMsg');
          }
        },
        (error) => {
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  // Get Behavioral Skill Details From Skill Master
  private getAllBehSkills() {
    this.loading = true;
    this.commonService
      .postAllBehSkills(undefined, this.nextPositionId)
      .pipe(first())
      .subscribe(
        (data) => {
          this.loading = false;
          if (data && data.length > 0) {
            this.behSkillList = data;
            this.initalizeBehSkillForm();
          } else {
            this.loading = false;
            localStorage.setItem(
              'errorMsg',
              'Behavioral Skills Data Not Found'
            );
            this.commonService.showerror();
            localStorage.removeItem('errorMsg');
          }
        },
        (error) => {
          this.loading = false;
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  private convertData(isFunctional, data) {
    var ratings1;
    if (isFunctional) ratings1 = data;
    else ratings1 = data;

    var ratings2 = [];
    this.dateRanges = [1];
    let j = 0;
    for (let i = 0; i < ratings1.length; i++) {
      var curIndex = this.getIndexOf(ratings2, ratings1[i].skillName);
      if (curIndex === -1) {
        ratings2[j] = [];
        ratings2[j][0] = ratings1[i].skillName;
        ratings2[j][1] = ratings1[i].skillScore;
        curIndex = j;
        j++;
      }

      // ratings2[curIndex].push(ratings1[i].skillScore);

      let newDateRange = this.formatDate(ratings1[i].skillRatingFromDate); //+ " - "
      // + this.formatDate(ratings1[i].skillRatingToDate);

      if (this.dateRanges.indexOf(newDateRange) === -1)
        this.dateRanges.push(newDateRange);
    }
    this.convertedData = ratings2;
  }

  // /fetch user information data
  private fetchPositions() {
    //var towerId = JSON.parse(localStorage.user).userData.towerId;
    this.commonService
      .getAllPositionInfo(null)
      .pipe(first())
      .subscribe(
        (data) => {
          this.positionList = data;
        },
        (error) => {
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  private getTowersListByIbuId(ibuId, towerId) {
    this.commonService.getTowersListByIbuId(ibuId, null).subscribe(
      (data) => {
        this.towerList = data;
        this.alltowerList = data;
        let selecteTower = this.towerList.find(
          (tower) => tower.towerId == towerId
        );
        this.selectedTowerId = selecteTower;
      },
      (error) => {
        localStorage.setItem('errorMsg', error.statusText);
        this.commonService.showerror();
        localStorage.removeItem('errorMsg');
      }
    );
  }

  private getFunctionListByIbuId(ibuId) {
    this.functionList = [];
    this.commonService.getFunctionListByIbuId(ibuId).subscribe(
      (data) => {
        this.functionList = data;
      },
      (error) => {
        localStorage.setItem('errorMsg', error.statusText);
        this.commonService.showerror();
        localStorage.removeItem('errorMsg');
      }
    );
  }

  private getAllIBUInfo() {
    this.loading = true;
    this.commonService
      .getAllIBUInfo()
      .pipe(first())
      .subscribe(
        (data) => {
          this.ibuList = data;
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  public setFieldsData(data) {
    this.commonService
      .allInfoPosition(data.nextPosition)
      .pipe(first())
      .subscribe(
        (data) => {
          if (data && data.length) {
            const response = data[0];
            this.modelData['isNextTowerSame'] =
              response.towerId == this.modelData['towerId'];
            this.modelData['nextPositionIbuName'] = response.ibuName;
            this.modelData['nextPositionTowerName'] = response.towerName;
            this.modelData['nextPositionFunctionName'] = response.functionName;
            console.log({ response, test: this.modelData });
          }
        },
        (error) => {
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  private onChangeIBU() {
    this.resetFunctionValue();
    this.resetTowerValue();
    if (this.ibu?.ibuId) {
      this.getFunctionListByIbuId(this.ibu?.ibuId);
      this.getTowersListByIbuId(this.ibu?.ibuId, 0);
    } else {
      this.resetFunctionList();
      this.resetTowerList();
    }
  }

  private onChangeFunction() {
    this.resetTowerValue();
    if (this.function?.functionId) {
      console.log(this.function?.functionId);
      this.towerList = this.alltowerList.filter(
        (item) => item.functionId == this.function.functionId
      );
    } else {
      this.towerList = this.alltowerList;
    }
  }

  private resetFunctionValue() {
    this.function = '';
  }

  private resetTowerValue() {
    this.tower = '';
  }

  private resetFunctionList() {
    this.functionList = [];
  }

  private resetTowerList() {
    this.towerList = [];
  }

  private getPositionName(positionId) {
    for (let i in this.positionList) {
      if (this.positionList[i].positionId == positionId)
        return this.positionList[i].positionName;
    }
  }

  private getIndexOf(arr, item) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i] && arr[i][0] === item) return i;
    }
    return -1;
  }

  //fetch user skills data
  private getAllNextPositions(userIds, towerId) {
    this.loading = true;
    this.commonService
      .getAllNextPositions(userIds, towerId)
      .pipe(first())
      .subscribe(
        (data) => {
          this.allPositions = data;
          var that = this;
          setTimeout(function () {
            that.loading = false;
          }, 1000);
        },
        (error) => {
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  private formatDate(dateStr) {
    return (
      new Date(dateStr).getDate() +
      '/' +
      (new Date(dateStr).getMonth() + 1) +
      '/' +
      new Date(dateStr).getFullYear()
    );
  }

  // edit user skill information data
  private onEditSubmit(userData, isFuntion) {
    this.fullBehRatingList = [];
    this.fullFunRatingList = [];
    this.convertedData = [];
    this.dateRanges = [1];
    if (isFuntion) this.getAllFunSkillsForUser(userData.userId);
    else this.getAllBehSkillsForUser(userData.userId);

    if (userData) {
      this.userUpdatedId = userData.userId;
      this.selectedPositionId = userData.positionId;
      this.selectedPositionId = userData.nextPosition;
      let groupForm = {
        skillRatingFromDate: new FormControl(
          this.common.getJSONObj(userData.skillRatingFromDate)
        ),
        skillRatingToDate: new FormControl(
          this.common.getJSONObj(userData.skillRatingFromDate)
        ),
      };
      if (isFuntion) {
        // set value of functional skill  from
        let userSkill = userData.funUserSkill;
        if (this.skillData && this.skillData.length > 0) {
          for (let i = 0; i < this.skillData.length; i++) {
            if (userSkill && userSkill.length > 0) {
              for (let j = 0; j < userSkill.length; j++) {
                if (userSkill[j].skillId == this.skillData[i].skillId) {
                  groupForm[this.skillData[i].skillName] = new FormControl(
                    userSkill[j].skillLevel
                  );
                }
              }
            }
            if (!groupForm[this.skillData[i].skillName]) {
              groupForm[this.skillData[i].skillName] = new FormControl('1');
            }
          }
        }
        this.functionalSkillRatingForm = this.formBuilder.group(groupForm);
      } else {
        // set value of behavioral skill  from
        let userSkill = userData.behUserSkill;
        if (this.behSkillList && this.behSkillList.length > 0) {
          for (let i = 0; i < this.behSkillList.length; i++) {
            if (userSkill && userSkill.length > 0) {
              for (let j = 0; j < userSkill.length; j++) {
                if (userSkill[j].skillId == this.behSkillList[i].skillId) {
                  groupForm[this.behSkillList[i].skillName] = new FormControl(
                    userSkill[j].skillLevel
                  );
                }
              }
            }
            if (!groupForm[this.behSkillList[i].skillName]) {
              groupForm[this.behSkillList[i].skillName] = new FormControl('1');
            }
          }
        }
        this.behavioralSkillRatingForm = this.formBuilder.group(groupForm);
      }
    }
  }

  // Get Behavioral Skill Details From Skill Master
  private getAllBehSkillsForUser(userId) {
    this.loading = true;

    this.commonService
      .getAllBehSelfRatingsForUser(this.towerId, userId)
      .pipe(first())
      .subscribe(
        (data) => {
          this.notAbleToFillRating = false;
          this.loading = false;
          if (data && data.length > 0) {
            this.fullBehRatingList = data;
            this.convertData(false, this.fullBehRatingList);
            this.showHideModel = true;
          } else {
            this.showHideModel = true;
            this.notAbleToFillRating = true;
            // this.closeModels();
            //this.loading = false;
            // localStorage.setItem('errorMsg', "Behavioral Ratings Data Not Found");
            // this.commonService.showerror();
            // localStorage.removeItem('errorMsg');
          }
        },
        (error) => {
          this.showHideModel = true;
          this.notAbleToFillRating = true;
          // this.loading = false;
          // localStorage.setItem('errorMsg', error.statusText);
          // this.commonService.showerror();
          // localStorage.removeItem('errorMsg');
        }
      );
  }

  // Get Behavioral Skill Details From Skill Master
  private getAllFunSkillsForUser(userId) {
    this.loading = true;
    this.commonService
      .getAllFunSelfRatingsForUser(this.towerId, userId)
      .pipe(first())
      .subscribe(
        (data) => {
          //this.userId
          this.notAbleToFillRating = false;
          this.loading = false;
          if (data && data.length > 0) {
            this.fullFunRatingList = data;
            this.convertData(true, this.fullFunRatingList);
            this.showHideModel = true;
          } else {
            this.showHideModel = true;
            this.notAbleToFillRating = true;
            this.loading = false;
            // // this.closeModels();
            // this.loading = false;
            // localStorage.setItem('errorMsg', "Functional Ratings Data Not Found");
            // this.commonService.showerror();
            // localStorage.removeItem('errorMsg');
          }
        },
        (error) => {
          this.showHideModel = true;
          this.notAbleToFillRating = true;
          this.loading = false;
          // this.loading = false;
          // localStorage.setItem('errorMsg', error.statusText);
          // this.commonService.showerror();
          // localStorage.removeItem('errorMsg');
        }
      );
  }

  //fetch skills data
  private fetchSkillsData() {
    this.commonService
      .postAllFunSkills(undefined, this.nextPositionId)
      .pipe(first())
      .subscribe(
        //fetchskillsdata()
        (data) => {
          this.skillData = data;
          console.log(this.skillData);
          this.initalizeFunSkillForm();
        },
        (error) => {
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  // /fetch user information data
  private fetchUserData(userId, towerId) {
    this.commonService
      .fetchUserData(userId, towerId, '')
      .pipe(first())
      .subscribe(
        (data) => {
          let userIds = [];
          for (let i = 0; i < data.length; i++) {
            if (data[i].userId) {
              userIds.push(data[i].userId);
            }
          }
          if (userIds.length > 0) {
            this.fetchData = data;
            for (let i in this.fetchData) {
              if (this.fetchData[i].userId == userId) {
                this.modelData = this.fetchData[i];
                this.setFieldsData(this.modelData);
                this.isAppr = this.fetchData[i].isApproved;
              }
            }
            // this.fetchData[0].isenabled = "false"
            // this.fetchUserFunctSkillsData(userIds, data);
          }
          this.getAllNextPositions(
            userIds,
            JSON.parse(localStorage.user).userData.towerId
          );
        },
        (error) => {
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  //fetch user functional skills data
  private fetchUserFunctSkillsData(userIds: any[], userData) {
    // this.commonService.fetchAllFunSkills(userIds).pipe(first()).subscribe(
    //   data => {
    //     for (let j = 0; j < userData.length; j++) {
    //       let userSkill = [];
    //       for (let i = 0; i < data.length; i++) {
    //         if (userData[j].userId == data[i].userId) {
    //           let skillLevel = data[i].skillLevel;
    //           let skillName = '';
    //           this.skillData.forEach((litem, index) => {
    //             if (litem.skillId == data[i].skillId) {
    //               skillName = litem.skillName
    //             }
    //           });
    //           userSkill.push({ skillId: data[i].skillId, skillLevel: skillLevel, skillName: skillName });
    //         }
    //       }
    //       userData[j]['funUserSkill'] = userSkill;
    //     }
    //     this.fetchData = userData;
    //     this.categoriseLeaveUsers()
    //     this.countActiveAndInactiveUsers();
    //     this.fetchUserBehSkillsData(userIds, this.fetchData);
    //   },
    //   error => {
    //     localStorage.setItem('errorMsg', error.statusText);
    //     this.commonService.showerror();
    //     localStorage.removeItem('errorMsg');
    //   }
    // )
  }

  //fetch user skills data
  private fetchUserBehSkillsData(userIds: any[], userData) {
    this.commonService
      .fetchAllBehSkills(userIds)
      .pipe(first())
      .subscribe(
        (data) => {
          for (let j = 0; j < userData.length; j++) {
            let userSkill = [];
            for (let i = 0; i < data.length; i++) {
              if (userData[j].userId == data[i].userId) {
                let skillLevel = data[i].skillLevel;
                let skillName = '';
                this.behSkillList.forEach((litem, index) => {
                  if (litem.skillId == data[i].skillId) {
                    skillName = litem.skillName;
                  }
                });
                userSkill.push({
                  skillId: data[i].skillId,
                  skillLevel: skillLevel,
                  skillName: skillName,
                });
              }
            }
            userData[j]['behUserSkill'] = userSkill;
          }
          this.fetchData = userData;
          this.categoriseLeaveUsers();
          this.countActiveAndInactiveUsers();
        },
        (error) => {
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }
  //categorise leave users
  private categoriseLeaveUsers() {
    for (let i = 0; i < this.fetchData.length; i++) {
      if (this.fetchData[i].skillRatingToDate) {
        let currentDate = new Date();
        let userskillRatingToDate = new Date(
          this.fetchData[i].skillRatingToDate
        );
        if (currentDate > userskillRatingToDate) {
          this.fetchData[i]['leaveStyle'] = 'red';
        }
      }
    }
  }

  // validate resoucre leaving date should be equal or lessthen from current date
  private countActiveAndInactiveUsers() {
    for (let i = 0; i < this.fetchData.length; i++) {
      let isFound = false;
      //remove user from the list if having leave date less then current date
      let currentTime = this.common.getTime(new Date());
      if (this.fetchData[i].skillRatingToDate) {
        let leavingTime = this.common.getTime(
          this.fetchData[i].skillRatingToDate
        );
        if (currentTime > leavingTime) {
          isFound = true;
        }
      }
      if (isFound) {
        this.fetchData[i]['leaveUserCSS'] = 'leaveUserCSS';
      } else {
        this.fetchData[i]['leaveUserCSS'] = '';
      }
    }
  }

  // suave user information
  private onSubmit(skillRatingForm, isFunctional) {
    debugger;
    if (isFunctional) {
      if (this.functionalSkillRatingForm.invalid) {
        this.submitted = true;
        return;
      }
    } else {
      if (this.behavioralSkillRatingForm.invalid) {
        this.submitted = true;
        return;
      }
    }
    let skillRatingData = this.setUserSkillData(
      skillRatingForm,
      this.userUpdatedId,
      isFunctional
    );
    let currentUserSkill = this.setUserCurrentSkillData(
      skillRatingForm,
      this.userUpdatedId,
      isFunctional
    );
    this.loading = true;

    this.commonService
      .saveSkillRatingData(
        skillRatingData,
        currentUserSkill,
        isFunctional,
        this.towerId
      )
      .pipe(first())
      .subscribe(
        (data) => {
          this.loading = false;
          this.closeModels();
          if (
            this.fetchData[0] &&
            data != 'Ratings are already present for these days.'
          ) {
            if (isFunctional) this.fetchData[0].isenabledFun = 'false';
            else this.fetchData[0].isenabledBeh = 'false';
          }
          this.isShowModel = false;
          localStorage.setItem('errorMsg', data);
          this.closeModels();
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        },
        (error) => {
          this.loading = false;
          localStorage.setItem('errorMsg', 'Must Enter all the fields');
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  //set user skill data
  private setUserSkillData(userFormDetails: any, userId: any, isFunctional) {
    let userSkillData = [];
    if (isFunctional) {
      for (let i = 0; i < this.skillData.length; i++) {
        // if (this.skillData[i].positionId != this.selectedPositionId) continue;

        let skillObj = {};
        skillObj['userId'] = userId;
        skillObj['skillId'] = this.skillData[i].skillId;
        skillObj['targetScore'] = this.skillData[i].targetScore;
        skillObj['skillScore'] = this.getScoreBySkillName(
          userFormDetails[this.skillData[i].skillName]
        );
        skillObj['skillRatingBy'] = this.users.emailAddress;
        skillObj['skillRatingFromDate'] = this.common.getDateYYMMDD(
          userFormDetails.skillRatingFromDate
        );
        skillObj['skillRatingToDate'] = this.common.getDateYYMMDD(
          userFormDetails.skillRatingToDate
        );
        skillObj['createDate'] = new Date();
        skillObj['ratedByRole'] = this.users.userRoll;
        userSkillData.push(skillObj);
      }
    } else {
      for (let i = 0; i < this.behSkillList.length; i++) {
        if (
          this.getScoreBySkillName(
            userFormDetails[this.behSkillList[i].skillName]
          ) === 0
        )
          continue;

        let skillObj = {};
        skillObj['userId'] = userId;
        skillObj['skillId'] = this.behSkillList[i].skillId;
        skillObj['targetScore'] = this.behSkillList[i].targetScore;
        skillObj['skillScore'] = this.getScoreBySkillName(
          userFormDetails[this.behSkillList[i].skillName]
        );
        skillObj['skillRatingBy'] = this.users.emailAddress;
        skillObj['skillRatingFromDate'] = this.common.getDateYYMMDD(
          userFormDetails.skillRatingFromDate
        );
        skillObj['skillRatingToDate'] = this.common.getDateYYMMDD(
          userFormDetails.skillRatingToDate
        );
        skillObj['createDate'] = new Date();
        skillObj['ratedByRole'] = this.users.userRoll;
        userSkillData.push(skillObj);
      }
    }
    return userSkillData;
  }

  private getScoreBySkillName(skillName) {
    let score = 1;
    if (skillName && skillName.trim().length > 0) {
      for (let i = 0; i < this.skillRatingData.length; i++) {
        if (
          this.skillRatingData[i].ratingName.toLowerCase() ==
          skillName.toLowerCase()
        ) {
          score = this.skillRatingData[i].score;
          break;
        }
      }
    }
    return score;
  }
  //set user skill data
  private setUserCurrentSkillData(
    userFormDetails: any,
    userId: any,
    isFunctional
  ) {
    let userSkillData = [];
    if (isFunctional) {
      for (let i = 0; i < this.skillData.length; i++) {
        //if (this.skillData[i].positionId != this.selectedPositionId) continue;
        let skillObj = {};
        skillObj['userId'] = userId;
        skillObj['skillId'] = this.skillData[i].skillId;
        skillObj['skillName'] = this.skillData[i].skillName;
        skillObj['skillLevel'] = Number(
          userFormDetails[this.skillData[i].skillName]
        );
        skillObj['createdByEmail'] = this.users.emailAddress;
        skillObj['skillRatingFromDate'] = this.common.getDateYYMMDD(
          userFormDetails.skillRatingFromDate
        );
        skillObj['skillRatingToDate'] = this.common.getDateYYMMDD(
          userFormDetails.skillRatingToDate
        );
        skillObj['ratedByRole'] = Number(this.users.userRoll);

        userSkillData.push(skillObj);
      }
    } else {
      for (let i = 0; i < this.behSkillList.length; i++) {
        // if (this.behSkillList[i].positionId != this.selectedPositionId)
        //   continue;

        let skillObj = {};
        skillObj['userId'] = userId;
        skillObj['skillId'] = this.behSkillList[i].skillId;
        skillObj['skillName'] = this.behSkillList[i].skillName;
        skillObj['skillLevel'] = Number(
          userFormDetails[this.behSkillList[i].skillName]
        );
        skillObj['createdByEmail'] = this.users.emailAddress;
        skillObj['skillRatingFromDate'] = this.common.getDateYYMMDD(
          userFormDetails.skillRatingFromDate
        );
        skillObj['skillRatingToDate'] = this.common.getDateYYMMDD(
          userFormDetails.skillRatingToDate
        );
        skillObj['ratedByRole'] = Number(this.users.userRoll);
        userSkillData.push(skillObj);
      }
    }
    return userSkillData;
  }

  //save skills data
  private saveSkillsData(userSkillData) {
    this.commonService
      .saveSkillsData(userSkillData, this.users.emailAddress)
      .pipe(first())
      .subscribe(
        (data) => {
          if (data && data != null) {
            this.functionalSkillRatingForm.reset();
            localStorage.setItem(
              'errorMsg',
              'User successfully added as a TR Nominee'
            );
            localStorage.setItem('isReload', 'true');
            this.commonService.showerror();
          }
        },
        (error) => {
          localStorage.setItem('errorMsg', 'Must Enter all the fields');
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  //set start date
  private setStartDate() {
    let currentDate = new Date();
    this.config.minDate = {
      year: currentDate.getFullYear(),
      month: currentDate.getMonth() + 1,
      day: currentDate.getDate(),
    };
  }

  //set end dates
  private setEndDate() {
    let currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + 1);
    currentDate.setMonth(currentDate.getMonth() + 3);
    if (this.functionalSkillRatingForm.value.skillRatingFromDate) {
      var dd = currentDate.getDate();
      var mm = currentDate.getMonth();
      var yy = currentDate.getFullYear();
      this.config.minDate = { year: yy, month: mm, day: dd };
    } else if (this.behavioralSkillRatingForm.value.skillRatingFromDate) {
      var dd = currentDate.getDate();
      var mm = currentDate.getMonth();
      var yy = currentDate.getFullYear();
      this.config.minDate = { year: yy, month: mm, day: dd };
    } else {
      localStorage.setItem('errorMsg', 'Please select Start Date');
      this.commonService.showerror();
      return;
    }
  }

  //close dailog box
  private closeModels() {
    this.closeModel1.nativeElement.click();
    this.closeModel2.nativeElement.click();
  }

  //forward to next section
  public gotoNextPage(e, routeURL) {
    this.router.navigate([routeURL]);
  }

  // logout and forward to login page
  private logout() {
    this.commonService.logout();
  }
}
